import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './marine-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class MarineDetailComponent extends AbstractCollectionDirective {}
